<app-escalation-detail
    *ngFor="let escalation of move.escalations"
    [escalation]="escalation"
    class="u-margin-bottom u-display-block"
></app-escalation-detail>
<p *ngIf="!move.escalations" class="u-color-muted">{{ 'EMPTY' | i18nKeyTranslate: i18nKeys.Escalation }}</p>
